import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/Hanwha_340W_bbb.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="Hanwha 340W - BBB" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Modules/Hanwha340WBBB.js